<div class="note" style="padding-bottom: 4px; text-align: right">
  <span
    style="
      color: #ff0000;
      font-style: normal;
      font-size: 1.2em;
      line-height: 0.3em;
      font-weight: bold;
      vertical-align: middle;
    "
    >*</span
  >
  indicates a required field
</div>
